import React, { useEffect, useState } from 'react';
import { BotaoComClose, BotaoError } from '../../StyledComponent';
import { Link } from 'react-router-dom';
import MsgSendNewCode from '../MsgSendNewCode';

import Fade from '@material-ui/core/Fade';
import Close from '../../Reutilizaveis/CloseButton';
import ChangePassword from '../ChangePassword';

import './styles.scss';

const EmailSent = ({ email, codigoInvalido, codigoAntigo }) => {
  const [codigo, setCodigo] = useState('');

  const [emailMasked, setEmailMasked] = useState('');
  const [showChangePassword, setShowChangePassword] = useState(false);

  const [resendCode, setResendCode] = useState(false);

  const [invalidCode, setInvalidCode] = useState(codigoInvalido);

  useEffect(() => {
    maskEmail();

    if (codigoInvalido != undefined) setCodigo(codigoAntigo);
  }, []);

  function maskEmail() {
    var maskedEmail = email.split('@');

    let tamanho = maskedEmail[0].split('');

    let toMask = maskedEmail[0].slice(1, tamanho.length - 1);

    let newStr = toMask.replace(/[a-z0-9]/gi, '*');

    let lastCharacter = tamanho.length - 1;

    setEmailMasked(
      tamanho[0] + newStr + tamanho[lastCharacter] + '@' + maskedEmail[1]
    );
  }
  const checkInvalidCode =
    invalidCode || invalidCode == !undefined ? true : false;
  return (
    <>
      {showChangePassword ? (
        <ChangePassword codigo={codigo} email={email} />
      ) : (
        <>
          {resendCode ? (
            <MsgSendNewCode email={email} />
          ) : (
            <Fade in>
              <div className='loginForm loginForgotPassword'>
                <div className='nova-senha centralized-column'>
                  <h1>Esqueci a senha:</h1>
                  <span>Autenticação dois fatores</span>
                  <p>Enviamos um código de verificação para o email:</p>
                  <span className='emailMasked'>{emailMasked}</span>

                  <div className='input centralized'>
                    <input
                      placeholder='DIGITE SEU CÓDIGO DE ACESSO'
                      maxLength='6'
                      inputMode='numeric'
                      id='txtVerifyCode'
                      autoComplete='off'
                      onChange={(event) => {
                        setCodigo(event.target.value);
                      }}
                      value={codigo}
                    />
                  </div>

                  <div className='centralized'>
                    <div className='centralized'>
                      {checkInvalidCode && (
                        <BotaoError
                          onClick={() => {
                            setCodigo('');
                            setInvalidCode(false);
                          }}
                        >
                          CÓDIGO INVÁLIDO
                        </BotaoError>
                      )}
                      {!checkInvalidCode && (
                        <>
                          <Link to='/'>
                            <Close
                              id='btnCancelForgotPassword'
                              tamanho='35px'
                              tamanhoIcone='25px'
                            />
                          </Link>
                          <BotaoComClose
                            color='#ffffff'
                            className='btnSubmit'
                            id='btnSaveNewPassword'
                            disabled={codigo.length < 6 ? true : false}
                            onClick={() => {
                              setShowChangePassword(true);
                            }}
                          >
                            CONFIRMAR
                          </BotaoComClose>
                        </>
                      )}
                    </div>
                  </div>
                  <div className='centralized-column nova-senha__btns'>
                    <button
                      className='nova-senha__btns__resendEmail'
                      id='btnNewCode'
                      onClick={(e) => {
                        e.preventDefault();
                        setResendCode(true);
                      }}
                    >
                      Não recebi um código
                    </button>
                  </div>
                </div>
              </div>
            </Fade>
          )}
        </>
      )}
    </>
  );
};

export default EmailSent;
